/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Link } from "react-router-dom";
import {
  Action,
  ActionType,
  Category,
  CategoryUI,
} from "../../entity/category.model";
import { categoryService } from "../../service/category.service";
import { mConstants } from "../../../../../helper/constants";

export interface BrandTableProps {
  data: Category[];
  onReload: () => void;
}

export default function CategoryTable(props: BrandTableProps) {
  const customerTableColumns: ColumnsType<CategoryUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    // {
    //   title: "UUID",
    //   dataIndex: "uuid",
    //   key: "uuid",
    // },
    {
      title: "Нэр",
      dataIndex: "category1Cname",
      key: "category1Cname",
    },
    {
      title: "Зураг",
      dataIndex: "imagePath",
      key: "imagePath",
      render: (imagePath: string) => {
        return (
          <div>
            <img
              src={
                mConstants.API_URL +
                mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                imagePath
              }
              alt="Төрөл зураг"
              style={{ width: "50px" }}
            />
          </div>
        );
      },
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: CategoryUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action, index) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      key={`action-${index}`}
                      to={`/category/${record.uuid}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                } else if (action.type === ActionType.delete) {
                  return (
                    <a
                      key={`delete-action-${record.uuid}`}
                      href="#"
                      className="dropdown-item"
                      onClick={() => {
                        Modal.confirm({
                          title: "Баталгаажуулах",
                          content: `Та устгахдаа итгэлтэй байна уу?`,
                          okText: "Үргэлжлүүлэх",
                          cancelText: "Хаах",
                          onOk: () => {
                            categoryService
                              .deleteCategory(record.uuid!)
                              .then(() => {
                                Modal.success({
                                  title: "Амжилттай",
                                  content: "Төрөл амжилттай устлаа.",
                                });
                                props.onReload();
                              })
                              .catch((e) => console.error(e));
                          },
                        });
                      }}
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </a>
                  );
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];
  const categoryUIs: CategoryUI[] = props.data.map((category, index) => {
    const actions: Action[] = [
      { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      { icon: "icon-trash", text: "Устгах", type: ActionType.delete },
    ];
    return {
      ...category,
      actions: actions,
      index: index + 1,
      key: index,
    };
  });

  return (
    <Table
      className="table table-responsive"
      columns={customerTableColumns}
      dataSource={categoryUIs}
      pagination={false}
    />
  );
}
